// ---------------------------------------------------------------------------
// Preferência "Mostrar caixa" da Section box.
//
// Esconder a caixa tira o desenho (arestas, faces e pegas) e mantém o
// corte. Pedido do Rui: com a caixa à volta de uma laje, as pegas tapavam
// a vista e apanhavam os cliques que eram para os elementos.
//
// Guardada por browser (localStorage), sempre com try/catch: num modo
// privado ou com o armazenamento bloqueado, a caixa aparece (o valor por
// omissão) e o resto funciona.
//
// Puro, menos o acesso ao armazenamento, que se pode passar de fora.
// ---------------------------------------------------------------------------

import { ESTILO_BASE_POR_OMISSAO, lerEstilo, type EstiloDeCorte } from './estilosDeCorte'

export const CHAVE_MOSTRAR_CAIXA = 'vn2r.sectionBox.mostrarCaixa'

function armazenamento(storage?: Storage | null): Storage | null {
  if (storage !== undefined) return storage
  try {
    return typeof localStorage === 'undefined' ? null : localStorage
  } catch {
    return null
  }
}

/** Lê a preferência. Sem nada guardado (ou com erro), a caixa vê-se: é
 *  o comportamento de sempre. */
export function lerMostrarCaixa(storage?: Storage | null): boolean {
  try {
    return armazenamento(storage)?.getItem(CHAVE_MOSTRAR_CAIXA) !== 'false'
  } catch {
    return true
  }
}

/** Grava a preferência. Falhar a gravar não é erro: dura esta sessão. */
export function gravarMostrarCaixa(v: boolean, storage?: Storage | null): void {
  try {
    armazenamento(storage)?.setItem(CHAVE_MOSTRAR_CAIXA, v ? 'true' : 'false')
  } catch {
    /* armazenamento cheio ou bloqueado */
  }
}

// ---------------------------------------------------------------------------
// Preferência "Preenchimento a cheio" dos cortes (caixa e planos).
//
// Ligada por omissão: sem ela as lajes cortadas viam-se como duas faces
// soltas. Desligá-la serve quem precisa de ver através do corte, ou um
// modelo tão grande que o cálculo demora.
// ---------------------------------------------------------------------------

export const CHAVE_PREENCHIMENTO = 'vn2r.corte.preenchimento'

export function lerPreenchimento(storage?: Storage | null): boolean {
  try {
    return armazenamento(storage)?.getItem(CHAVE_PREENCHIMENTO) !== 'false'
  } catch {
    return true
  }
}

export function gravarPreenchimento(v: boolean, storage?: Storage | null): void {
  try {
    armazenamento(storage)?.setItem(CHAVE_PREENCHIMENTO, v ? 'true' : 'false')
  } catch {
    /* armazenamento cheio ou bloqueado */
  }
}

// ---------------------------------------------------------------------------
// Estilo base do preenchimento (fundo e trama). Preferência de quem
// desenha, como a escala de uma planta: as regras por material e classe
// são trabalho e vão na sessão.
// ---------------------------------------------------------------------------

export const CHAVE_ESTILO_BASE = 'vn2r.corte.estiloBase'

export function lerEstiloBase(storage?: Storage | null): EstiloDeCorte {
  try {
    const raw = armazenamento(storage)?.getItem(CHAVE_ESTILO_BASE)
    return raw ? lerEstilo(JSON.parse(raw)) : ESTILO_BASE_POR_OMISSAO
  } catch {
    return ESTILO_BASE_POR_OMISSAO
  }
}

export function gravarEstiloBase(e: EstiloDeCorte, storage?: Storage | null): void {
  try {
    armazenamento(storage)?.setItem(CHAVE_ESTILO_BASE, JSON.stringify(e))
  } catch {
    /* armazenamento cheio ou bloqueado */
  }
}
